"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStorageItem = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var CookieStorageItem = (function () {
    function CookieStorageItem(key, maxAgeInSeconds) {
        this.key = key;
        this.maxAgeInSeconds = maxAgeInSeconds;
    }
    CookieStorageItem.prototype.get = function () {
        var value = js_cookie_1.default.get(this.key);
        return value !== null && value !== void 0 ? value : null;
    };
    CookieStorageItem.prototype.set = function (value) {
        var _a;
        var options = {
            Secure: typeof window === 'undefined' || window.location.hostname !== 'localhost',
            'Max-Age': (_a = this.maxAgeInSeconds) === null || _a === void 0 ? void 0 : _a.toString(),
        };
        js_cookie_1.default.set(this.key, value, options);
    };
    CookieStorageItem.prototype.remove = function () {
        js_cookie_1.default.remove(this.key);
    };
    return CookieStorageItem;
}());
exports.CookieStorageItem = CookieStorageItem;
//# sourceMappingURL=cookie-storage-item.js.map